import { createContext, useContext, useEffect, useState } from "react";
import { ScreeningContext } from "./ScreeningContext";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const { screeningData } = useContext(ScreeningContext);

  useEffect(() => {
    if (screeningData?.displayLanguage) {
      const detectedLanguage = screeningData.displayLanguage.toLowerCase();
      if (
        detectedLanguage === "es" ||
        detectedLanguage === "spanish" ||
        detectedLanguage === "español"
      ) {
        setCurrentLanguage("es");
      } else {
        setCurrentLanguage("en");
      }
    }
  }, [screeningData?.displayLanguage]);

  const changeLanguage = language => {
    if (["en", "es"].includes(language)) {
      setCurrentLanguage(language);
    }
  };

  const value = {
    currentLanguage,
    changeLanguage,
    isSpanish: currentLanguage === "es",
    isEnglish: currentLanguage === "en",
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
